var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvvTooltip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 48,
    viewBox: "0 0 73 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2610567"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11",
    width: 73,
    height: 48,
    rx: 4,
    fill: "#D4D5E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 9 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 8C67 6.89543 66.1046 6 65 6H41C39.8954 6 39 6.89543 39 8V20C39 21.1046 39.8954 22 41 22H65C66.1046 22 67 21.1046 67 20V8ZM39 4C37.8954 4 37 4.89543 37 6V22C37 23.1046 37.8954 24 39 24H67C68.1046 24 69 23.1046 69 22V6C69 4.89543 68.1046 4 67 4H39Z",
    fill: "#FF1C1C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    x: 39,
    y: 6,
    width: 28,
    height: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: 1234
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2457 10.0994V17.3722H42.7081V11.5589H42.6655L41 12.603V11.2393L42.8004 10.0994H44.2457Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9743 17.3722V16.2642L48.563 13.8672C48.7832 13.6541 48.9679 13.4624 49.117 13.2919C49.2685 13.1214 49.3833 12.9545 49.4615 12.7912C49.5396 12.6255 49.5787 12.4467 49.5787 12.255C49.5787 12.0419 49.5301 11.8584 49.4331 11.7045C49.336 11.5483 49.2034 11.4287 49.0353 11.3459C48.8672 11.2607 48.6767 11.218 48.4636 11.218C48.2411 11.218 48.0469 11.263 47.8812 11.353C47.7155 11.4429 47.5877 11.572 47.4977 11.7401C47.4077 11.9081 47.3627 12.1082 47.3627 12.3402H45.9032C45.9032 11.8643 46.0109 11.4512 46.2264 11.1009C46.4418 10.7505 46.7437 10.4794 47.1319 10.2876C47.5202 10.0959 47.9676 10 48.4743 10C48.9951 10 49.4485 10.0923 49.8343 10.277C50.2226 10.4593 50.5244 10.7126 50.7399 11.0369C50.9553 11.3613 51.063 11.733 51.063 12.152C51.063 12.4266 51.0086 12.6977 50.8997 12.9652C50.7931 13.2327 50.6026 13.5298 50.3279 13.8565C50.0533 14.1809 49.6663 14.5703 49.1667 15.0249L48.1049 16.0653V16.1151H51.1589V17.3722H45.9743Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9613 17.4716C54.431 17.4716 53.9587 17.3804 53.5444 17.1982C53.1325 17.0135 52.8069 16.7602 52.5678 16.4382C52.3311 16.1139 52.2092 15.7398 52.2021 15.3161H53.7504C53.7598 15.4936 53.8178 15.6499 53.9244 15.7848C54.0333 15.9174 54.1777 16.0204 54.3576 16.0938C54.5375 16.1671 54.7399 16.2038 54.9648 16.2038C55.1992 16.2038 55.4064 16.1624 55.5863 16.0795C55.7662 15.9967 55.9071 15.8819 56.0089 15.7351C56.1107 15.5883 56.1616 15.419 56.1616 15.2273C56.1616 15.0331 56.1071 14.8615 55.9982 14.7124C55.8917 14.5608 55.7378 14.4425 55.5366 14.3572C55.3377 14.272 55.101 14.2294 54.8263 14.2294H54.1481V13.1001H54.8263C55.0584 13.1001 55.2631 13.0599 55.4407 12.9794C55.6206 12.8989 55.7603 12.7876 55.8597 12.6456C55.9592 12.5012 56.0089 12.3331 56.0089 12.1413C56.0089 11.959 55.9651 11.7992 55.8775 11.6619C55.7923 11.5223 55.6715 11.4134 55.5153 11.3352C55.3614 11.2571 55.1815 11.218 54.9755 11.218C54.7672 11.218 54.5766 11.2559 54.4038 11.3317C54.2309 11.4051 54.0924 11.5104 53.9883 11.6477C53.8841 11.785 53.8285 11.946 53.8214 12.1307H52.3477C52.3548 11.7116 52.4743 11.3423 52.7063 11.0227C52.9383 10.7031 53.2508 10.4534 53.6438 10.2734C54.0392 10.0911 54.4854 10 54.9826 10C55.4845 10 55.9237 10.0911 56.3001 10.2734C56.6765 10.4557 56.9689 10.7019 57.1772 11.0121C57.3879 11.3198 57.4921 11.6655 57.4897 12.049C57.4921 12.4562 57.3654 12.7959 57.1097 13.0682C56.8564 13.3404 56.5262 13.5133 56.119 13.5866V13.6435C56.654 13.7121 57.0612 13.898 57.3406 14.201C57.6223 14.5017 57.762 14.8781 57.7596 15.3303C57.762 15.7446 57.6424 16.1127 57.4009 16.4347C57.1618 16.7566 56.8316 17.0099 56.4102 17.1946C55.9888 17.3793 55.5058 17.4716 54.9613 17.4716Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7548 16.0938V14.8828L61.791 10.0994H62.8351V11.7756H62.2172L60.3031 14.8047V14.8615H64.6177V16.0938H58.7548ZM62.2456 17.3722V15.7244L62.274 15.1882V10.0994H63.7157V17.3722H62.2456Z",
    fill: "#171717"
  })), /*#__PURE__*/React.createElement("g", {
    id: "xxx xxx xxxx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40625 38L8.5071 40.0135L9.62571 38H10.9858L9.34162 40.7273L11.0142 43.4545H9.66122L8.5071 41.4908L7.36364 43.4545H6L7.66193 40.7273L6.04261 38H7.40625Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0312 38L14.1321 40.0135L15.2507 38H16.6108L14.9666 40.7273L16.6392 43.4545H15.2862L14.1321 41.4908L12.9886 43.4545H11.625L13.2869 40.7273L11.6676 38H13.0312Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 38L19.7571 40.0135L20.8757 38H22.2358L20.5916 40.7273L22.2642 43.4545H20.9112L19.7571 41.4908L18.6136 43.4545H17.25L18.9119 40.7273L17.2926 38H18.6562Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7617 38L27.8626 40.0135L28.9812 38H30.3413L28.6971 40.7273L30.3697 43.4545H29.0167L27.8626 41.4908L26.7191 43.4545H25.3555L27.0174 40.7273L25.3981 38H26.7617Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3867 38L33.4876 40.0135L34.6062 38H35.9663L34.3221 40.7273L35.9947 43.4545H34.6417L33.4876 41.4908L32.3441 43.4545H30.9805L32.6424 40.7273L31.0231 38H32.3867Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0117 38L39.1126 40.0135L40.2312 38H41.5913L39.9471 40.7273L41.6197 43.4545H40.2667L39.1126 41.4908L37.9691 43.4545H36.6055L38.2674 40.7273L36.6481 38H38.0117Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1172 38L47.218 40.0135L48.3366 38H49.6967L48.0526 40.7273L49.7251 43.4545H48.3722L47.218 41.4908L46.0746 43.4545H44.7109L46.3729 40.7273L44.7536 38H46.1172Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7422 38L52.843 40.0135L53.9616 38H55.3217L53.6776 40.7273L55.3501 43.4545H53.9972L52.843 41.4908L51.6996 43.4545H50.3359L51.9979 40.7273L50.3786 38H51.7422Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3672 38L58.468 40.0135L59.5866 38H60.9467L59.3026 40.7273L60.9751 43.4545H59.6222L58.468 41.4908L57.3246 43.4545H55.9609L57.6229 40.7273L56.0036 38H57.3672Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9922 38L64.093 40.0135L65.2116 38H66.5717L64.9276 40.7273L66.6001 43.4545H65.2472L64.093 41.4908L62.9496 43.4545H61.5859L63.2479 40.7273L61.6286 38H62.9922Z",
    fill: "#5B646C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ALEX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64773 17.2727H6L8.51065 10H10.4922L12.9993 17.2727H11.3516L9.52983 11.6619H9.47301L7.64773 17.2727ZM7.54474 14.4141H11.4368V15.6143H7.54474V14.4141Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8746 17.2727V10H15.4123V16.005H18.5302V17.2727H13.8746Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5485 17.2727V10H24.449V11.2678H21.0861V13.0007H24.1969V14.2685H21.0861V16.005H24.4632V17.2727H19.5485Z",
    fill: "#5B646C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1133 10L28.5799 12.4787H28.6367L30.1104 10H31.8469L29.6275 13.6364L31.8967 17.2727H30.1282L28.6367 14.7905H28.5799L27.0884 17.2727H25.3271L27.6033 13.6364L25.3697 10H27.1133Z",
    fill: "#5B646C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvvTooltip2);
export default __webpack_public_path__ + "static/media/cvv-tooltip-2.ef8b06da77540e2a190c34cd6a7c9714.svg";
export { ForwardRef as ReactComponent };